type HandleAddressErrorRequestProps = {
  error: Error;
};

export const handleAddressErrorRequest = ({ error }: HandleAddressErrorRequestProps) => {
  // @ts-expect-error status not available
  const errorStatus = error.status;
  const title = errorStatus === 404 ? 'Adres niet gevonden' : 'Tijdelijk niet beschikbaar';
  const message =
    errorStatus === 404
      ? 'We kunnen dit adres niet vinden. Controleer of de gegevens correct zijn ingevuld en probeer het opnieuw.'
      : 'Door een technische storing kunnen we de gegevens op dit moment niet tonen. Probeer het later opnieuw.';

  // Maps the response to the correct response for the view
  const networkAvailability = {
    title: title,
    message: message,
    available: false,
    status: errorStatus,
  };

  return {
    networkAvailability,
  };
};
